import { StatsCard } from '@/components/Custom/Card/StatsCard';
import { twMerge } from 'tailwind-merge';
import { InfoTip } from '@/components/Help/InfoTip';
import type { HelpTip } from '@/docs/tips/types';

interface ActivityCardProps {
  title: string;
  description: string;
  number: number;
  containerClassName?: string;
  titleClassName?: string;
  numberClassName?: string;
  /** "i" icon explaining the figure. */
  infoTip?: HelpTip;
}

export const ActivityCard = ({
  title,
  description,
  number,
  containerClassName,
  titleClassName,
  numberClassName,
  infoTip,
}: ActivityCardProps) => {
  return (
    <StatsCard
      containerClassName={twMerge(
        'shadow-none min-w-[210px] min-3xl:min-w-[230px]',
        containerClassName,
      )}
      titleClassName={twMerge('font-medium', titleClassName)}
      numberClassName={twMerge('mt-2.25', numberClassName)}
      title={
        infoTip ? (
          <span className="inline-flex items-center gap-1.5">
            {title}
            <InfoTip tip={infoTip} />
          </span>
        ) : (
          title
        )
      }
      description={description}
      number={number}
    />
  );
};
